import { basketSelectors } from '@store/basket/selectors';
import { guestSelectors } from '@store/guest/selectors';
import { connect } from 'react-redux';
import { formValueSelector } from 'redux-form';
import { spaPackageFormConfig } from '../../shared';
import { GuestDetailsAndSelections } from './GuestDetailsAndSelections';
import { StateProps } from './GuestDetailsAndSelections.types';

const valueSelector = formValueSelector(spaPackageFormConfig.form);

const mapStateToProps = (state): StateProps => ({
  loggedInGuest: guestSelectors.getGuest(state),
  availableGuests: basketSelectors.getBasketGuests(state),
  selectedGuests: valueSelector(state, 'guests'),
});

export const GuestDetailsAndSelectionsConnected: any =
  connect(mapStateToProps)(GuestDetailsAndSelections);
